module.exports = __webpack_public_path__ + "0038078ad4fa1e4ef64d799955ec4856.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ppfPreview/day_80.jpg
// module id = 1689
// module chunks = 5